import axios from "axios";
import {ApiResponseHandler} from "./handler/apiResponse.handler";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.response.use(
response => ApiResponseHandler.handleSuccess(response),
error => ApiResponseHandler.handleError(error)
);

export default api;
